export const Headers = Object.freeze({
  ORGANIZACION_ID: "X-MILEGAJO-ORGANIZACION-ID",
  EMPRESA_ID: "X-MILEGAJO-EMPRESA-ID",
  USUARIO_ID: "X-MILEGAJO-USUARIO-ID",
  TIPO_USUARIO: "X-MILEGAJO-TIPO-USUARIO",
  USUARIO_ID: "X-MILEGAJO-USUARIO-ID",
});
